<template>
  <section
    class="divider"
    :style="componentStyle"
  />
</template>

<script setup>
import { useStyle } from '@/composables/app/useStyle'

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { componentStyle } = useStyle(section.style)
</script>

<style lang="scss" scoped>
.divider {
  display: block;
  width: 100%;
  height: 36px;
}
</style>
